import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export interface UseTriggerEvaluationCountFilter {
  datasetId: string;
}

export function getQueryKey(filter: UseTriggerEvaluationCountFilter) {
  return ["triggerEvaluationCount", filter];
}

export function useTriggerEvaluationCount(
  filter: UseTriggerEvaluationCountFilter,
  resourceOwnerId?: string,
): UseQueryResult<number, Error> {
  const { triggerEvaluationService } = useDomainServices();
  const { datasetId } = filter;

  return useQuery({
    queryKey: getQueryKey(filter),
    queryFn: ({ signal }) =>
      triggerEvaluationService.getTriggerEvaluationCountForDataset(datasetId, {
        abortSignal: signal,
        resourceOwnerId,
      }),
    placeholderData: (previousData) => previousData,
  });
}
